module.exports = "/static/assets/45363a20eb3d7b2a57429ebc71777d1d.png";